module.exports = __webpack_public_path__ + "static/media/home.e27da602.svg";